import React, { useEffect, useState } from 'react';
import { Box, Preloader } from '@common-fe/common-fe';
import styled from 'styled-components';

import { DocumentPagePreview } from '@/components/controls/DropScan/dropScan.types';
import useConvertTiffToPng from '@/utils/hooks/useConvertTiffToPng';

const RoundedImg = styled.img`
  ${({ theme }) => theme.shadows.active};
  border-radius: ${({ theme }) => theme.rounds.container2Round};
`;

interface Props {
  url?: string;
  alt?: string;
  onSetPreviews?: (previews: DocumentPagePreview[]) => void;
}

const TiffScanViewer: React.FC<Props> = ({ url, alt, onSetPreviews }) => {
  const { pngDocuments, isLoading } = useConvertTiffToPng({ url });
  const [previews, setPreviews] = useState<DocumentPagePreview[]>([]);

  useEffect(() => {
    if (pngDocuments?.length) {
      const newPreviews = pngDocuments.map(
        (pngDocument): DocumentPagePreview => ({
          ...pngDocument,
          pageRef: React.createRef<HTMLDivElement>(),
        })
      );

      setPreviews(newPreviews);

      if (onSetPreviews) {
        onSetPreviews(newPreviews);
      }
    }
  }, [pngDocuments, onSetPreviews]);

  if (isLoading) {
    return (
      <Box height="60px" justify="center" align="center">
        <Preloader testId="tiff-document-preloader" />
      </Box>
    );
  }

  return (
    <Box height={{ min: 'auto' }}>
      {previews.map((pngDocument) => (
        <Box
          key={pngDocument?.id}
          ref={pngDocument.pageRef}
          margin={{ top: 'spacing12' }}
        >
          <RoundedImg
            src={pngDocument?.link}
            alt={alt}
          />
        </Box>
      ))}
    </Box>
  );
};

export default TiffScanViewer;
